import React, { useEffect, useRef, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import Select from "react-select";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { delete_icon, dummyimage } from "../../../assets/img";
import { URLS } from "../../../Services/Constant";
import { get, post, put } from "../../../Services/ApiHandler";
import { toast } from "react-toastify";

const AddBookingHistoryBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const inputRefs = useRef([]);

  const type = location?.state?.type;
  const data = location?.state?.data;
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [fromDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("On Going");
  const [blocks, setBlocks] = useState([]);
  const [optionsList, setOptionsList] = useState({
    states: [],
    cities: [],
  });
  const [addedStateCities, setAddedStateCities] = useState({
    states: new Set(),
    cities: new Set(),
  });
  console.log("added state cities", addedStateCities);
  useEffect(() => {
    getLocationsList(2);
    let viewId = location.state?.data?.id;
    if (viewId) viewDetails(viewId);
  }, []);

  const checkAvailableLocations = async (from, to) => {
    let payload = {
      type: 2,
      start_date: from,
      end_date: to,
      banner_id: data?.id,
    };
    let res = await post(URLS.BANNER_AVAILABILITY, payload);
    console.log("banner availability", res);
    if (res?.status === "success") {
      let stateIds = new Set(res?.unavailable_states?.map((item) => item?.id));
      let cityIds = new Set(res?.unavailable_cities?.map((item) => item?.id));
      if (city && cityIds.has(city?.value)) setCity(null);
      setAddedStateCities({
        cities: cityIds,
        states: stateIds,
      });
    }
  };

  const viewDetails = async (id) => {
    let res = await get(`${URLS.BANNER_ADD}${id}/details/`);
    console.log("banner view res", res);
    if (res?.status === "success") {
      let d = res?.data;
      getLocationsList(3, d?.state);
      setFormDate(d?.start_date);
      setToDate(d?.end_date);
      setState({ value: d?.state, label: d?.state_name });
      setCity({ value: d?.city, label: d?.city_name });
      checkAvailableLocations(d?.start_date, d?.end_date);
      setBlocks(
        (d?.images ?? [])?.map((item) => ({
          ...item,
          selectedImage: item?.image,
          fromDate: item?.start_time,
          toDate: item?.end_time,
        })),
      );
    }
  };

  //get  locations
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION + "?type=" + type}${
      parent_id ? "&parent_id=" + parent_id : ""
    }`;
    const res = await get(url);
    console.log("locations list", res, type, parent_id);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      if (type === 2) {
        setOptionsList((prev) => ({ ...prev, states: modifiedList }));
      } else if (type === 3) {
        setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
      } else {
        setOptionsList((prev) => ({ ...prev, areas: modifiedList }));
      }
    }
  };

  const handleAddBlock = () => {
    setBlocks((prev) => [
      ...prev,
      {
        selectedImage: "",
        url: "",
        fromDate: "",
        toDate: "",
      },
    ]);
  };

  const handleDeleteBlock = (indexToDelete) => {
    setBlocks((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleChange = (index, field, value) => {
    const updated = [...blocks];
    updated[index][field] = value;
    setBlocks(updated);
  };

  const handleImageChange = (index, file) => {
    const updated = [...blocks];
    updated[index].selectedImage = file;
    updated[index]["id"] = null;
    setBlocks(updated);
  };

  const validateForm = () => {
    const newErrors = {};
    let isBannerHasEmptyFeild = false;
    // Required selects
    if (!state) newErrors.state = "State is required";
    if (!city && addedStateCities.states.has(state?.value)) {
      toast.error("This state already has banners. Please select a city.");
      newErrors.city = "City is required";
    }

    // Required dates
    if (!fromDate) newErrors.startDate = "Start date is required";
    if (!toDate) newErrors.endDate = "End date is required";
    else if (new Date(toDate) < new Date(fromDate)) {
      newErrors.endDate = "End date cannot be before start date";
    }

    blocks.forEach((item) => {
      Object.entries(item).forEach((val) => {
        if (!val[1] && val[0] !== "id" && val[0] !== "url")
          isBannerHasEmptyFeild = true;
      });
    });
    if (blocks.length === 0 || isBannerHasEmptyFeild) {
      toast.error(
        blocks.length === 0
          ? "Please Add Banners"
          : "Please Fill All the Details",
      );
      newErrors.emptyFeild = "empty";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    let payload = new FormData();

    // Append simple fields
    payload.append("type", 32);
    payload.append("country", 1);
    payload.append("state", state?.value || "");
    payload.append("city", city?.value || "");
    payload.append("start_date", fromDate || "");
    payload.append("end_date", toDate || "");

    // Append images array
    blocks?.forEach((item, index) => {
      if (type === "edit") {
        if (Boolean(item?.id)) {
          payload.append(`image_ids[]`, item.id);
          payload.append(`urls[]`, item?.url || "");
          payload.append(`start_times[]`, item?.fromDate || "");
          payload.append(`end_times[]`, item?.toDate || "");
        } else {
          payload.append(`new_images[]`, item.selectedImage);
          payload.append(`new_urls[]`, item?.url || "");
          payload.append(`new_start_times[]`, item?.fromDate || "");
          payload.append(`new_end_times[]`, item?.toDate || "");
        }
      } else {
        // Append other properties
        payload.append(`images[]`, item.selectedImage);
        payload.append(`urls[]`, item?.url || "");
        payload.append(`start_times[]`, item?.fromDate || "");
        payload.append(`end_times[]`, item?.toDate || "");
      }
    });
    console.log("payload banner", payload);
    let method = type === "edit" ? put : post;
    let res = await method(
      `${URLS.BANNER_ADD}${type === "edit" ? `${data?.id}/edit` : "add"}/`,
      payload,
    );
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate(-1);
    }
  };
  console.log("from data to date", fromDate, toDate, blocks);
  return (
    <div className="">
      <Topbar header={type == "add" ? "Add Banner" : "Edit Banner"} />
      <div className="d-flex flex-wrap gap-4">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Country
          </p>
          <input
            className="input-box"
            name="userName"
            readOnly
            value={"India"}
            type="text"
            placeholder="User Name"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            State
          </p>
          <Select
            className="select-loc"
            options={optionsList.states}
            value={state}
            onChange={(selectedOption) => {
              setState(selectedOption);
              setErrors((prev) => ({ ...prev, state: "" }));
              getLocationsList(3, selectedOption?.value);
            }}
            placeholder={"State"}
          />
          {errors.state && <p className="err">{errors.state}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            City
          </p>
          <Select
            className="select-loc"
            options={optionsList.cities?.filter(
              (item) =>
                !addedStateCities.cities?.has(item?.value) ||
                item?.value === city?.value,
            )}
            value={city}
            onChange={(selectedOption) => {
              setCity(selectedOption);
              setErrors((prev) => ({ ...prev, city: "" }));
            }}
            placeholder={"City"}
          />
          {errors.city && <p className="err">{errors.city}</p>}
        </div>
      </div>
      <div className="d-flex gap-3 mt-4">
        <div className="">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            {" "}
            Start Date
          </p>
          <input
            type="date"
            value={fromDate}
            max={toDate}
            onChange={(e) => {
              const newValue = e.target.value;
              setFormDate(newValue);
              setErrors((prev) => ({
                ...prev,
                startDate: newValue ? "" : prev.startDate,
                endDate:
                  toDate && new Date(toDate) >= new Date(newValue)
                    ? ""
                    : prev.endDate,
              }));
            }}
            className="input-box "
            placeholder="From Date"
          />
          {errors.startDate && <p className="err">{errors.startDate}</p>}
        </div>
        <div className="">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            {" "}
            End Date
          </p>
          <input
            type="date"
            value={toDate}
            min={fromDate}
            onChange={(e) => {
              const newValue = e.target.value;
              setToDate(newValue);
              checkAvailableLocations(fromDate, newValue);
              setErrors((prev) => ({
                ...prev,
                endDate:
                  newValue && new Date(newValue) >= new Date(fromDate)
                    ? ""
                    : prev.endDate,
              }));
            }}
            className="input-box"
            placeholder="To Date"
          />
          {errors.endDate && <p className="err">{errors.endDate}</p>}
        </div>
      </div>
      <div className="mt-5">
        <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
          Upload Banner
        </h2>
        <p className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ">
          {" "}
          Max Size: 5MB | Aspect Ratio: 330:191 Supported Sizes: 660×382,
          990×573, 1320×764
        </p>
      </div>

      <div className="d-flex ae-jb gap-1 ">
        {/* {type == "edit" && ( */}
        <div className="col-md-8">
          {blocks?.map((block, index) => (
            <div className="roles-bg " key={index}>
              <div className="d-flex ae-jb gap-2">
                <div className="position-relative w-10">
                  <div
                    className="position-relative w-100"
                    onClick={() => inputRefs[index]?.click()}
                  >
                    <HighlightOffRoundedIcon
                      className="img-cancel"
                      style={{ height: "20px", width: "20px", zIndex: 0 }}
                    />
                    <div className="d-flex ac-jb w-100">
                      <div>
                        <img
                          alt="preview"
                          style={{ width: "50px", height: "50px" }}
                          src={
                            typeof block.selectedImage === "string"
                              ? block.selectedImage || dummyimage
                              : block.selectedImage
                                ? URL.createObjectURL(block.selectedImage)
                                : dummyimage
                          }
                        />
                        <input
                          ref={(el) => (inputRefs[index] = el)}
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={(e) =>
                            handleImageChange(index, e.target.files[0])
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <input
                  style={{ height: "30px" }}
                  type="url"
                  value={block.url}
                  onChange={(e) => handleChange(index, "url", e.target.value)}
                  className="input-box "
                  placeholder="Enter URL"
                />

                <div className="d-flex gap-3">
                  <div>
                    <p className="f3 fs-xs-8">Start Time</p>
                    <input
                      style={{ height: "30px" }}
                      type="time"
                      value={block.fromDate}
                      onChange={(e) => {
                        handleChange(index, "fromDate", e.target.value);
                        handleChange(index, "toDate", e.target.value);
                      }}
                      className="input-box"
                    />
                  </div>
                  <div>
                    <p className="f3 fs-xs-8">End Time</p>
                    <input
                      style={{ height: "30px" }}
                      type="time"
                      value={block.toDate}
                      min={block.fromDate}
                      onChange={(e) => {
                        let formattedTo = Number(
                          e.target.value?.replace(":", ""),
                        );
                        let formattedFrom = Number(
                          block.fromDate?.replace(":", ""),
                        );
                        if (formattedTo > formattedFrom)
                          handleChange(index, "toDate", e.target.value);
                      }}
                      className="input-box"
                    />
                  </div>
                </div>
                {type === "edit" && (
                  <input
                    type="text"
                    value={block?.status}
                    style={{ height: "30px", width: "100px" }}
                    className={`${
                      block?.status === "ongoing" ? "bg-green white" : ""
                    } input-box text-center`}
                    disabled
                  />
                )}

                {/* {type === "add" && blocks.length != 1 && ( */}
                <button
                  className="cust-btn"
                  onClick={() => handleDeleteBlock(index)}
                  type="button"
                >
                  <img src={delete_icon} alt="" className="mx-2 edit-btn" />
                </button>
                {/* )} */}
              </div>
            </div>
          ))}
        </div>
        {/* )} */}
        <button
          onClick={handleAddBlock}
          className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Add
        </button>
      </div>
      {errors.blocks && <p className="err">{errors.blocks}</p>}
      <div className="d-flex ac-js gap-3 mt-5">
        <button
          onClick={() => navigate("/home-banners")}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          style={{ minWidth: "20%" }}
        >
          Cancel
        </button>
        {type != "view" && (
          <button
            onClick={handleSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            style={{ minWidth: "20%" }}
          >
            {type == "edit" ? "Submit" : "Add"}
          </button>
        )}
      </div>
    </div>
  );
};

export default AddBookingHistoryBanner;
